import { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Box, Button, Modal, Text } from '@workwhile/ui'
import { SelectLeadShiftsStep } from './steps/SelectLeadShiftsStep'
import { LinkLeadShiftsFormValues } from './types'

interface Props {
  companyId: number
  shiftId: number
  timezone: string
  open: boolean
  onClose: () => void
}

const FORM_ID = 'link-lead-shifts-form'

export const LinkLeadShiftsFlow = ({
  companyId,
  shiftId,
  timezone,
  open,
  onClose,
}: Props) => {
  const form = useForm<LinkLeadShiftsFormValues>({
    defaultValues: { leadShiftIds: [] },
  })
  const selectedCount = form.watch('leadShiftIds').length

  const handleClose = useCallback(() => {
    form.reset()
    onClose()
  }, [form, onClose])

  const onSubmit = form.handleSubmit(() => {
    // TODO: submit once the link lead shifts endpoint exists:
    // - shiftId: the led shift the lead shifts are being linked to
    // - leadShiftIds: the selected lead shift ids
    handleClose()
  })

  return (
    <Modal
      open={open}
      onClose={handleClose}
      width={[1, 800]}
      ariaTitle="Select shifts to link"
      customCta={
        <>
          {selectedCount > 0 ? (
            <Text fontWeight="bold" fontSize={3} mr={4}>
              {selectedCount} Selected
            </Text>
          ) : null}
          <Box width={120}>
            <Button
              block
              type="submit"
              form={FORM_ID}
              disabled={selectedCount === 0}
            >
              Save
            </Button>
          </Box>
        </>
      }
    >
      <FormProvider {...form}>
        <form id={FORM_ID} onSubmit={onSubmit}>
          <SelectLeadShiftsStep
            companyId={companyId}
            shiftId={shiftId}
            timezone={timezone}
          />
        </form>
      </FormProvider>
    </Modal>
  )
}
